import { Text } from '@/components/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ModalButton, Wrapper, WrapperText } from './styled';

const SendCodePassModal: React.FC<any> = ({ closeModal, email }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    closeModal();
  };

  return (
    <Wrapper>
      <WrapperText>
        <img src="/images/radio/checked.svg" alt="" width={40} height={40} />
        <Text
          color="primary"
          variant="titleModal"
          style={{
            margin: '16px auto 16px auto',
            maxWidth: '199px',
            width: '100%',
            textAlign: 'center',
            fontSize: '18px',
          }}
        >
          {t('CHECK_YOUR_INBOX')}
        </Text>
        <Text color="secondary" variant="content" size="15">
          <Trans
            i18nKey="SEND_RESET_TO_MAIL_CONTENT"
            values={{ email }}
            components={{
              email: <span className="fs-mask" />,
            }}
          />
        </Text>
      </WrapperText>
      <ModalButton variant="contained" color="dark" onClick={handleClose}>
        {t('CLOSE')}
      </ModalButton>
    </Wrapper>
  );
};

export default SendCodePassModal;
